import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getMemberships } from "../../network/Sales";
import SubInfo from "../admin/common/SubInfo";

type Props = { memberships: any; setMemberships: any };

const SelectMembershipSale = ({ memberships, setMemberships }: Props) => {
  const intl = useIntl();
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  const [searchValue, setSearchValue] = useState("");
  const { data } = useQuery(["memberships"], () => getMemberships(locationId));

  const handleAddMembership = (membershipId: number): void => {
    const membership = data?.data?.find(
      (membership: any) => membership.id === membershipId
    );
    if (!membership) return; // return if no product matches the ID
    const newMembership = {
      ...membership,
      itemable_id: membership.id,
      itemable_type: "membership",
      quantity: 1,
    };
    setMemberships((prevMemberships: any) => [
      ...prevMemberships,
      newMembership,
    ]);
  };
  const options = data?.data?.map((membership: any) => {
    if (memberships.find((s: any) => s.id === membership.id)) {
      return {
        label: (
          <div className="flex justify-between p-1" key={membership?.id}>
            <p>{membership?.name}</p>
            <SubInfo
              value={+membership?.price}
              label={intl.formatMessage({
                id: "SAR",
                defaultMessage: "ريال سعودي",
              })}
            />
          </div>
        ),
        value: membership?.id,
        key: membership?.id,
        disabled: true,
      };
    } else {
      return {
        label: (
          <div className="flex justify-between p-1" key={membership?.id}>
            <p>{membership?.name}</p>
            <SubInfo
              value={+membership?.price}
              label={intl.formatMessage({
                id: "SAR",
                defaultMessage: "ريال سعودي",
              })}
            />
          </div>
        ),
        value: membership?.id,
        key: membership?.id,
        disabled: false,
      };
    }
  });
  console.log(data);
  return (
    <Select
      className="w-full"
      onSearch={(value) => {
        setSearchValue(value);
      }}
      onChange={(value) => {
        handleAddMembership(value);
        if (value && searchValue) {
          setSearchValue("");
        }
      }}
      // labelRender={(option) => <div></div>}
      showSearch
      placeholder={intl.formatMessage({ id: "addMembershipPlaceholder" })}
      filterOption={false}
      options={options}
    />
  );
};

export default SelectMembershipSale;
